export const CITY_CONFIG = {
  'metepec': {
    name: 'Metepec',
    displayName: 'Metepec',
    state: 'Estado de México',
    stateSlug: 'estado-de-mexico',
    citySlug: 'metepec'
  },
  'acapulco': {
    name: 'Acapulco de Juarez',
    displayName: 'Acapulco',
    state: 'Guerrero',
    stateSlug: 'guerrero',
    citySlug: 'acapulco'
  },
  'carmen': {
    name: 'Ciudad del Carmen',
    displayName: 'Ciudad del Carmen',
    state: 'Campeche',
    stateSlug: 'campeche',
    citySlug: 'carmen'
  },
  'aguascalientes': {
    name: 'Aguascalientes',
    displayName: 'Aguascalientes',
    state: 'Aguascalientes',
    stateSlug: 'aguascalientes',
    citySlug: 'aguascalientes'
  },
  'cancun': {
    name: 'Cancún',
    displayName: 'Cancún',
    state: 'Quintana Roo',
    stateSlug: 'quintana-roo',
    citySlug: 'cancun'
  },
  'tijuana': {
    name: 'Tijuana',
    displayName: 'Tijuana',
    state: 'Baja California',
    stateSlug: 'baja-california',
    citySlug: 'tijuana'
  },
  'xalapa': {
    name: 'Xalapa',
    displayName: 'Xalapa',
    state: 'Veracruz',
    stateSlug: 'veracruz',
    citySlug: 'xalapa'
  }
  // ... otras ciudades
};

// Helpers para obtener slugs
export const getStateSlug = (stateName) => {
  return Object.values(CITY_CONFIG).find(city => 
    city.state === stateName
  )?.stateSlug;
};

export const getCitySlug = (cityName) => {
  return Object.values(CITY_CONFIG).find(city => 
    city.name === cityName
  )?.citySlug;
}; 